const select =
  'id,title,description,reportGroupId,isPublic,isActive,type,provider,ownerUserId,powerBIReportID,processId';

export default {
  paged: {
    select: 'id,isActive,type,title,provider,ownerUserId,powerBIReportId,isPublic',
    searchSelect: ['title', 'powerBIReportId', 'reportGroup/name'],
    orderBy: 'title',
    expand: {
      reportGroup: { select: 'id,name' },
    },
  },
  // Embedded detail (`/reports/:groupId/:reportId`) — no restrictive `$select`
  // so Power BI filter flags are preserved; expand group for the hero.
  report: {
    expand: {
      reportGroup: { select: 'id,name,powerBIReportGroupId' },
    },
  },
  item: {
    expand: {
      reportGroup: { select: 'id,name,powerBIReportGroupId' },
      reportDataFilterDynamicEntity: { select: 'id,displayName' },
      ownerUser: { select: 'id,fullName' },
      process: { select: 'id,name' },
    },
  },
  itemDetail: {
    expand: {
      reportGroup: { select: 'id,name,powerBIReportGroupId' },
      reportDataFilterDynamicEntity: { select: 'id,displayName' },
      ownerUser: { select: 'id,fullName' },
      process: { select: 'id,name' },
    },
  },
  groups: {
    select: 'id,name',
    searchSelect: ['name'],
    notSelectSearch: 'reports',
    expand: {
      reports: { count: true },
    },
  },
  reports: {
    select,
    searchSelect: ['title', 'description', 'reportGroup/name'],
    notSelectSearch: 'reportGroup',
    expand: {
      reportGroup: { select: 'id,name' },
    },
    orderBy: 'title',
  },
  favorites: {
    select,
    searchSelect: ['title', 'description'],
    notSelectSearch: 'reportGroup,reports',
    expand: {
      reportGroup: { select: 'id,name' },
    },
    orderBy: 'title',
  },
};
